<template>
  <div class="page-change-password">
    <h3>CHANGE PASSWORD</h3>
    <hr>
    <el-form class="form-change-password"
             ref="form"
             status-icon
             :rules="rules"
             :model="form"
             label-width="80px">
      <el-form-item label="原密码"
                    prop="oldPassword">
        <el-input placeholder="请输入原密码"
                  maxlength="16"
                  v-model="form.oldPassword"></el-input>
      </el-form-item>
      <el-form-item label="新密码"
                    prop="newPassword">
        <el-input placeholder="请输入新密码"
                  maxlength="16"
                  v-model="form.newPassword"></el-input>
      </el-form-item>
      <el-form-item label="确认密码"
                    prop="checkPassword">
        <el-input placeholder="请输入确认密码"
                  maxlength="16"
                  v-model="form.checkPassword"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   class="sub-button"
                   @click="submitForm('form')">提交</el-button>
        <el-button @click="resetForm('form')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data () {
    var checkOldPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('原密码不能为空！'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.form.newPassword !== '') {
          this.$refs.form.validateField('checkPassword')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        checkPassword: ''
      },
      rules: {
        oldPassword: [
          { validator: checkOldPassword, trigger: 'blur' }
        ],
        newPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        this.httpRequest(valid)
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    async httpRequest (valid) {
      if (valid) {
        let params = {
          oldPassword: this.form.oldPassword,
          newPassword: this.form.newPassword,
          checkPassword: this.form.checkPassword
        }
        try {
          let { data } = await this.$api.changePassword.password(params)
          console.log('datadata', data)
          if (Number(data.code) === 200) {
            console.log(200)
            this.$message.success('修改密码成功！')
            this.$router.push('/login')
            // let path = this.$route.query.redirect || '/login'
          } else {
            console.log('!200')
            this.$message.error('修改密码失败！')
          }
        } catch (e) {
          console.log('catch')
          this.$message.error('修改密码失败！')
        }
      } else {
        console.log('error submit!!')
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 768px) and (max-width: 1040px) {
}

@media (max-width: 420px) {
}
</style>

<style lang="scss">
@media (max-width: 768px) {
}

.page-change-password {
  margin: 1rem;
  background: white;
}
.form-change-password {
  width: 50%;
  margin: auto;
  margin-top: 40px;
  .el-icon-circle-check {
    font-size: 12px;
  }
}
// .sub-button {
//   background: #ffd012;
//   border: 1px solid #ffd012;
// }
// .sub-buttom :hover {
//   background: #fac80f;
// }
</style>
